import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchSpaceConflicts } from '../api/projects.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { Id, SpaceConflict } from '@/shared/types/domain';

/**
 * O alerta do REVISOR (US-20, §4.6). `enabled` por quem chama: o painel de
 * decisão só existe para quem tem `reviewProject`, e a RPC recusaria a
 * consulta de qualquer forma — evitar o disparo evita o erro previsível.
 */
export function useSpaceConflicts(
  projectId: Id | undefined,
  enabled = true,
): UseQueryResult<SpaceConflict[]> {
  return useQuery({
    queryKey: queryKeys.spaceConflicts(projectId ?? ''),
    queryFn: () => fetchSpaceConflicts(projectId as Id),
    enabled: Boolean(projectId) && enabled,
    staleTime: 30_000,
  });
}
